import { Badge, Button, ListItem } from '@mui/material';
import { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { SidebarContext } from 'src/contexts/SidebarContext';

interface SidebarMenuItemProps {
  link?: string;
  tab?: string;
  icon?: any;
  badge?: string;
  open?: boolean;
  name: string;
  disabled?: boolean;
}

const SidebarProjectMenuItem: FC<SidebarMenuItemProps> = ({
  link = '#',
  tab,
  icon: Icon,
  badge,
  name,
  disabled,
  ...rest
}) => {
  const { closeSidebar, setCurrentTab } = SidebarContext();

  return (
    <ListItem component="div" key={name} {...rest}>
      <Button
        style={{ opacity: disabled ? 0.5 : 1 }}
        disableRipple
        onClick={() => {
          closeSidebar();
          setCurrentTab(tab || '');
        }}
        to={link}
        startIcon={Icon && <Icon />}
        component={NavLink}
        disabled={disabled}
      >
        {name}
        {badge && <Badge badgeContent={badge} />}
      </Button>
    </ListItem>
  );
};

export default SidebarProjectMenuItem;
